var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('company-details',{attrs:{"company":_vm.company,"remote_measures":_vm.remote_measures,"is_following":_vm.is_following,"origin":_vm.origin},on:{"backToHome":_vm.backToHome}})}
var staticRenderFns = []

export { render, staticRenderFns }